<mat-card>
    <mat-card-header>
        <mat-card-title id="inforReport" class="mat-card-title-custom">{{'contract_personal_create.card_title' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel [(expanded)]="isExpanded" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'report_components.filter_title' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form #myForm="ngForm" class="pb-3" >
                  <div class="row" >
                        <!-- Khách hàng -->
                        <div class="col-lg-4 col-md-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.customer' | translate}}</mat-label>
                                <mat-select #signCustomerSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false;"
                                    (focus)="commonService.openComboBox(checkFocus, signCustomerSelect)" id="customerId"
                                    name="customerId" [(ngModel)]="documents.customerId" [multiple]="true">
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="signCustomerFilterCtrl">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option #allSelectedCustomer (click)="clickOptionSignCustomerAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option [value]="0" (click)="clickOptionSignCustomer(null)">
                                        {{ 'search_form.no_customer' | translate }}
                                    </mat-option>
                                    <mat-option *ngFor="let signCustomer of filteredSignCustomer | async"
                                        [value]="signCustomer.id" (click)="clickOptionSignCustomer(signCustomer)">
                                        {{ signCustomer.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian lập (từ ngày) -->
                        <div class="col-lg-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.created_date_from' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdFromDateRef" [max]="documents.createdToDate"
                                    #createdFromDateCtrl="ngModel"
                                    (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['createdFromDate'])"
                                    name="createdFromDate" #pickerInput [(ngModel)]="documents.createdFromDate"
                                    maxlength="200" (focus)="createdDateErr = 'createdFromDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="createdFromDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdFromDateRef></mat-datepicker>
                                <mat-error *ngIf="createdFromDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>

                                <mat-error
                                    *ngIf="createdFromDateCtrl?.errors?.matDatepickerMax && createdDateErr == 'createdFromDate'">
                                    {{ 'search_form.created_date_from' | translate }}
                                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                                    {{ 'search_form.created_date_to' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian lập (đến ngày) -->
                        <div class="col-lg-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.created_date_to' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdToDateRef" [min]="documents.createdFromDate"
                                    (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['createdToDate'])"
                                    name="createdToDate" #pickerInput1 [(ngModel)]="documents.createdToDate"
                                    #createdToDateCtrl="ngModel" maxlength="200"
                                    (focus)="createdDateErr = 'createdToDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="createdToDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdToDateRef></mat-datepicker>
                                <mat-error *ngIf="createdToDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="createdToDateCtrl?.errors?.matDatepickerMin && createdDateErr == 'createdToDate'">
                                    {{ 'search_form.created_date_to' | translate }}
                                    {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                                    {{ 'search_form.created_date_from' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian hết hạn (từ ngày) -->
                        <div class="col-lg-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.expired_date_from' | translate }}</mat-label>
                                <input matInput [matDatepicker]="expiredFromDateRef" [max]="documents.expiredToDate"
                                    #expiredFromDateCtrl="ngModel"
                                    (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['expiredFromDate'])"
                                    name="expiredFromDate" #pickerInput2 [(ngModel)]="documents.expiredFromDate"
                                    maxlength="200" (focus)="expiredDateErr = 'expiredFromDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="expiredFromDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #expiredFromDateRef></mat-datepicker>
                                <mat-error *ngIf="expiredFromDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="expiredFromDateCtrl?.errors?.matDatepickerMax && expiredDateErr == 'expiredFromDate'">
                                    {{ 'search_form.expired_date_from' | translate }}
                                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                                    {{ 'search_form.expired_date_to' | translate }}
                                </mat-error>

                            </mat-form-field>
                        </div>

                        <!-- Thời gian hết hạn (đến ngày) -->
                        <div class="col-lg-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.expired_date_to' | translate }}</mat-label>
                                <input matInput [matDatepicker]="expiredToDateRef" [min]="documents.expiredFromDate"
                                    (change)="this.commonService.resetDatePicker(pickerInput3.value, this.ngForm.controls['expiredToDate'])"
                                    name="expiredToDate" #pickerInput3 [(ngModel)]="documents.expiredToDate"
                                    #expiredToDateCtrl="ngModel" maxlength="200"
                                    (focus)="expiredDateErr = 'expiredToDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="expiredToDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #expiredToDateRef></mat-datepicker>
                                <mat-error *ngIf="expiredToDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="expiredToDateCtrl?.errors?.matDatepickerMin && expiredDateErr == 'expiredToDate'">
                                    {{ 'search_form.expired_date_to' | translate }}
                                    {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                                    {{ 'search_form.expired_date_from' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Mã hợp đồng -->
                        <div class="col-lg-4 col-12">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractCode = documents.contractCode == undefined ? '' : (documents.contractCode + '').trim()"
                                    #focusInput matInput [placeholder]="'search_form.doc_code' | translate"
                                    name="contractCode" [(ngModel)]="documents.contractCode" maxlength="200"
                                    autocomplete="off">
                                <button mat-button *ngIf="documents.contractCode" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractCode=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Tên hợp đồng -->
                        <div class="col-lg-4 col-12">
                            <mat-form-field class="w-100">
                                <input type="text"
                                    (focusout)="documents.contractName = documents.contractName == undefined ? '' : (documents.contractName + '').trim()"
                                    #focusInput matInput [placeholder]="'headertable.doc_name' | translate"
                                    name="contractName" [(ngModel)]="documents.contractName" maxlength="200"
                                    autocomplete="off">
                                <button mat-button *ngIf="documents.contractName" type="button" matSuffix
                                    mat-icon-button aria-label="Clear" (click)="documents.contractName=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <!-- Loại dịch vụ -->
                        <div class="col-lg-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'form.service_type' | translate}}</mat-label>
                                <mat-select #serviceTypeSelect [formControl]="selectedOptions"
                                    (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType"
                                    name="serviceType" [(ngModel)]="documents.serviceTypeId" [multiple]="true">
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="serviceTypesFilterCtrl">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option #allSelected (click)="clickOptionServiceTypeAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                                        <i class="fa fa-circle-o-notch fa-spin"></i>
                                    </div>
                                    <mat-option *ngFor="let serviceType of filteredServiceTypes | async"
                                        [value]="serviceType.id" (click)="clickOptionServiceType()">
                                        {{serviceType.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Trạng thái -->
                        <div class="col-lg-2 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.status' | translate}}</mat-label>
                                <mat-select #statusSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status"
                                    name="status" [(ngModel)]="documents.status" multiple>
                                    <mat-option #allSelectedStatus (click)="clickOptionStatusAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option [value]="EnumContractStatus.DRAFT" (click)="clickOptionStatus()">
                                        {{'search_form.draft' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.PROCESSING" (click)="clickOptionStatus()">
                                        {{'search_form.processing' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.REJECTED" (click)="clickOptionStatus()">
                                        {{'search_form.denied_sign' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT" (click)="clickOptionStatus()" *ngIf="isNotAttestedUser">
                                        {{'search_form.wait_confirm_enterprice_no_moit' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.FINISHED" (click)="clickOptionStatus()">
                                        {{'search_form.finish' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.CANCELLED" (click)="clickOptionStatus()">
                                        {{'search_form.cancelled' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.CONNECTING" (click)="clickOptionStatus()"
                                        *ngIf="!isNotAttestedUser">
                                        {{'search_form.connecting' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.TERMINATING" (click)="clickOptionStatus()">
                                        {{'contract_terminate.terminating' | translate}}</mat-option>
                                    <mat-option [value]="EnumContractStatus.TERMINATED" (click)="clickOptionStatus()">
                                        {{'contract_terminate.terminated' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                                                                        <!-- Loại tài nguyên trừ số lượng -->
                                                                        <div class="col-md-6 col-lg-4">
                                                                            <mat-form-field class="w-100">
                                                                                <mat-label>{{'search_form.resource_type_minus_quantity' | translate}}</mat-label>
                                                                                <mat-select #resourceSelect (focusout)="(checkFocus = true)"
                                                                                    (selectionChange)="checkFocus = false"
                                                                                    (focus)="commonService.openComboBox(checkFocus, resourceSelect)" id="resource"
                                                                                    name="resource" [(ngModel)]="documents.typeEnterpriseResource" multiple>
                                                                                    <mat-option #allSelectedResource (click)="clickOptionResourceAll()">
                                                                                        {{ 'form.choose_all' | translate }}
                                                                                    </mat-option>
                                                                                    <mat-option [value]="'CONTRACT_LIGHT'" (click)="clickOptionResource()">
                                                                                        {{'search_form.resource_1mb' | translate}}</mat-option>
                                                                                    <mat-option [value]="'CONTRACT'" (click)="clickOptionResource()">
                                                                                        {{'search_form.resource_10mb' | translate}}</mat-option>
                                                                                </mat-select>
                                                                            </mat-form-field>
                                                                        </div>
                      <!-- Thời gian ký (từ ngày) -->
                    <div class="col-lg-2 col-6">
                      <mat-form-field class="w-100">
                        <mat-label>{{ 'search_form.signed_date_from' | translate }}</mat-label>
                        <input matInput [matDatepicker]="signedFromDateRef" [max]="documents.signedToDate"
                               #signedFromDateCtrl="ngModel"
                               (change)="this.commonService.resetDatePicker(pickerInput4.value, this.ngForm.controls['signedFromDate'])"
                               name="signedFromDate" #pickerInput4 [(ngModel)]="documents.signedFromDate"
                               maxlength="200" (focus)="signedDateErr = 'signedFromDate'" autocomplete="off" />
                        <mat-datepicker-toggle matSuffix [for]="signedFromDateRef">
                          <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                             [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                        </mat-datepicker-toggle>
                        <mat-datepicker #signedFromDateRef></mat-datepicker>
                        <mat-error *ngIf="signedFromDateCtrl?.errors?.matDatepickerParse">
                          {{'validation.format_of_date' | translate}}
                        </mat-error>
                        <mat-error
                          *ngIf="signedFromDateCtrl?.errors?.matDatepickerMax && signedDateErr == 'signedFromDate'">
                          {{ 'search_form.signed_date_from' | translate }}
                          {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                          {{ 'search_form.signed_date_to' | translate }}
                        </mat-error>

                      </mat-form-field>
                    </div>

                      <!-- Thời gian ký (đến ngày) -->
                    <div class="col-lg-2 col-6">
                      <mat-form-field class="w-100">
                        <mat-label>{{ 'search_form.signed_date_to' | translate }}</mat-label>
                        <input matInput [matDatepicker]="signedToDateRef" [min]="documents.signedFromDate"
                               (change)="this.commonService.resetDatePicker(pickerInput5.value, this.ngForm.controls['signedToDate'])"
                               name="signedToDate" #pickerInput5 [(ngModel)]="documents.signedToDate"
                               #signedToDateCtrl="ngModel" maxlength="200"
                               (focus)="signedDateErr = 'signedToDate'" autocomplete="off" />
                        <mat-datepicker-toggle matSuffix [for]="signedToDateRef">
                          <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                             [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                        </mat-datepicker-toggle>
                        <mat-datepicker #signedToDateRef></mat-datepicker>
                        <mat-error *ngIf="signedToDateCtrl?.errors?.matDatepickerParse">
                          {{'validation.format_of_date' | translate}}
                        </mat-error>
                        <mat-error
                          *ngIf="signedToDateCtrl?.errors?.matDatepickerMin && signedDateErr == 'signedToDate'">
                          {{ 'search_form.signed_date_to' | translate }}
                          {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                          {{ 'search_form.signed_date_from' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Mẫu hợp đồng -->
                    <div class="col-lg-4 col-md-6">
                        <mat-form-field class="w-100">
                            <mat-label>{{'search_form.contract_template' | translate}}</mat-label>
                            <mat-select #templateSelect (focusout)="(checkFocus = true)"
                                (selectionChange)="checkFocus = false"
                                (focus)="commonService.openComboBox(checkFocus, templateSelect)" id="templateIds"
                                name="templateIds" [(ngModel)]="documents.templateIds" [multiple]="true">
                                <mat-option>
                                    <ngx-mat-select-search
                                        [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                        [placeholderLabel]="'search_form.search' | translate"
                                        [formControl]="templateFilterCtrl">
                                    </ngx-mat-select-search>
                                </mat-option>
                                <mat-option #allSelectedTemplate (click)="clickOptionTemplateAll()">
                                    {{ 'form.choose_all' | translate }}
                                </mat-option>
                                <mat-option *ngFor="let template of filteredTemplates | async"
                                    [value]="template.id" (click)="clickOptionTemplate()">
                                    {{ template.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!--  Phương thức lập-->
                    <div class="col-lg-4 col-6">
                        <mat-form-field class="w-100">
                            <mat-label>{{'search_form.method_creation' | translate}}</mat-label>
                            <mat-select #typeIdSelect (focusout)="(checkFocus = true)"
                                (selectionChange)="checkFocus = false"
                                (focus)="commonService.openComboBox(checkFocus, typeIdSelect)" id="typeId"
                                name="typeId" [(ngModel)]="documents.typeId">
                                <mat-option selected (click)="this.commonService.closeDropdownList(this.typeIdSelect)">
                                    {{ 'form.select_all' | translate }}
                                </mat-option>
                                <mat-option [value]="1" (click)="this.commonService.closeDropdownList(this.typeIdSelect)">
                                    {{'search_form.upload' | translate}}</mat-option>
                                <mat-option [value]="0" (click)="this.commonService.closeDropdownList(this.typeIdSelect)">
                                    {{'search_form.template' | translate}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- Hình thức tài liệu -->
                    <div class="col-lg-4 col-md-6">
                        <mat-form-field class="w-100">
                        <mat-label>{{'contract_terminate.form_type' | translate}}</mat-label>
                        <mat-select #formTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, formTypeSelect)" id="formType" name="formType"
                                    [(ngModel)]="documents.formType">
                            <mat-option selected (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                            {{'form.select_all' | translate}}</mat-option>
                            <mat-option [value]="'CONTRACT'"
                                        (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                            {{'contract_terminate.contract' | translate}}</mat-option>
                            <mat-option [value]="'CONTRACT_TERMINATION'"
                                        (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                            {{'contract_terminate.terminate' | translate}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                    </div>
                  </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>

        <!-- Group and sort -->
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title">
                        {{'search_form.sort_and_group' | translate}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form #groupForm="ngForm" class="pb-3">
                    <div class="row">
                        <!-- Trạng thái -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.group' | translate}}</mat-label>
                                <mat-select #groupBySelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, groupBySelect)" id="groupBy"
                                    name="groupBy" [(ngModel)]="documents.groupBy">
                                    <mat-option [value]="null" (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.unselect_group' | translate}}</mat-option>
                                    <mat-option value="serviceType"
                                        (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.type_of_doc' | translate}}</mat-option>
                                    <mat-option value="customerId"
                                        (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.customer' | translate}}</mat-option>
                                    <mat-option value="status" (click)="commonService.closeDropdownList(groupBySelect)">
                                        {{'search_form.status' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Sắp xếp theo -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.sort' | translate}}</mat-label>
                                <mat-select #sortBySelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false; onChangeSortSelection()"
                                    (focus)="commonService.openComboBox(checkFocus, sortBySelect)" id="sortName"
                                    name="sortName" [(ngModel)]="sortName">
                                    <mat-option [value]="null" (click)="unSelectSort()">
                                        {{'search_form.unselect_sort' | translate}}</mat-option>
                                    <mat-option value='expiredDate'
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'search_form.end_date' | translate}}</mat-option>
                                    <mat-option value="createdTime"
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'search_form.start_date' | translate}}</mat-option>
                                    <mat-option value="contractCode"
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'search_form.doc_code' | translate}}</mat-option>
                                    <mat-option value="contractName"
                                        (click)="commonService.closeDropdownList(sortBySelect)">
                                        {{'headertable.doc_name' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Loại sắp xếp -->
                        <div class="col-md-4 col-12">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.sort_type' | translate}}</mat-label>
                                <mat-select #sortTypeSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, sortTypeSelect)" id="sortType"
                                    name="sortType" [(ngModel)]="sortType">
                                    <mat-option value='ASC'
                                        *ngIf="sortName === 'expiredDate' || sortName === 'createdTime'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'search_form.new_to_old' | translate}}</mat-option>
                                    <mat-option value="DESC"
                                        *ngIf="sortName === 'expiredDate' || sortName === 'createdTime'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'search_form.old_to_new' | translate}}</mat-option>
                                    <mat-option value="ASC"
                                        *ngIf="sortName === 'contractCode' || sortName === 'contractName'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'A >> Z' | translate}}</mat-option>
                                    <mat-option value="DESC"
                                        *ngIf="sortName === 'contractCode' || sortName === 'contractName'"
                                        (click)="commonService.closeDropdownList(sortTypeSelect)">
                                        {{'Z >> A' | translate}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                </form>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>

    <div class="row mt-3" style="margin-bottom: 15px;">
        <div class="col-lg-12 d-flex justify-content-center">
            <button mat-raised-button color="primary" type="submit" (click)="onExportReport()"
                [disabled]="!myForm.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">receipt_long</mat-icon>
                {{'total_contract_report.title_btn' | translate}}
            </button>
        </div>
    </div>
</mat-card>
<app-history-report [mode]="mode" [formExport]="exportForm" (filterForm)="filterForm($event)"></app-history-report>
<ng4-loading-spinner *ngIf="showSpinner" [threshold]="1000" [timeout]="100000" [zIndex]="9999"></ng4-loading-spinner>
